import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { IconButton, InputAdornment } from '@mui/material'

export const CommonEndAdornment: FC<{
  showPassword: boolean
  handleShowPassword: () => void
}> = React.memo(({ showPassword, handleShowPassword }) => {
  const { t } = useTranslation('main')
  const handleStrayClicks = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>): void => {
      event.preventDefault()
    },
    []
  )
  return (
    <InputAdornment position="end">
      <IconButton
        aria-label={t('common.aria.passwordVisibility')}
        onClick={handleShowPassword}
        onMouseDown={handleStrayClicks}
        edge="end"
        tabIndex={-1}
      >
        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </IconButton>
    </InputAdornment>
  )
})
